/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseBlogCategoryFragment, BlogCategoryFragment, FullBlogCategoryFragment} from '@amblique/contentful/app/contentful/fragments/blog-category';

/**
 * Get a single BlogCategory by ID (base - scalars only)
 */
export const getBaseBlogCategoryById = gql`
  ${BaseBlogCategoryFragment}

  query GetBaseBlogCategoryById($id: String!, $locale: String!, $preview: Boolean) {
    blogCategory(id: $id, locale: $locale, preview: $preview) {
      ...BaseBlogCategoryFragment
    }
  }
`;

/**
 * Get a single BlogCategory by ID (standard - 1 level deep)
 */
export const getBlogCategoryById = gql`
  ${BlogCategoryFragment}

  query GetBlogCategoryById($id: String!, $locale: String!, $preview: Boolean) {
    blogCategory(id: $id, locale: $locale, preview: $preview) {
      ...BlogCategoryFragment
    }
  }
`;

/**
 * Get a single BlogCategory by ID (full - 2 levels deep)
 */
export const getFullBlogCategoryById = gql`
  ${FullBlogCategoryFragment}

  query GetFullBlogCategoryById($id: String!, $locale: String!, $preview: Boolean) {
    blogCategory(id: $id, locale: $locale, preview: $preview) {
      ...FullBlogCategoryFragment
    }
  }
`;

/**
 * Get a single BlogCategory by slug (base - scalars only)
 */
export const getBaseBlogCategoryBySlug = gql`
  ${BaseBlogCategoryFragment}

  query GetBaseBlogCategoryBySlug($slug: String!, $locale: String!, $preview: Boolean) {
    blogCategoryCollection(
      where: { slug: $slug }
      limit: 1
      locale: $locale
      preview: $preview
    ) {
      items {
        ...BaseBlogCategoryFragment
      }
    }
  }
`;

/**
 * Get a single BlogCategory by slug (standard - 1 level deep)
 */
export const getBlogCategoryBySlug = gql`
  ${BlogCategoryFragment}

  query GetBlogCategoryBySlug($slug: String!, $locale: String!, $preview: Boolean) {
    blogCategoryCollection(
      where: { slug: $slug }
      limit: 1
      locale: $locale
      preview: $preview
    ) {
      items {
        ...BlogCategoryFragment
      }
    }
  }
`;

/**
 * Get a single BlogCategory by slug (full - 2 levels deep)
 */
export const getFullBlogCategoryBySlug = gql`
  ${FullBlogCategoryFragment}

  query GetFullBlogCategoryBySlug($slug: String!, $locale: String!, $preview: Boolean) {
    blogCategoryCollection(
      where: { slug: $slug }
      limit: 1
      locale: $locale
      preview: $preview
    ) {
      items {
        ...FullBlogCategoryFragment
      }
    }
  }
`;

/**
 * Get all BlogCategory entries with pagination (base - scalars only)
 */
export const getBaseBlogCategorys = gql`
  ${BaseBlogCategoryFragment}

  query GetBaseBlogCategorys(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BlogCategoryOrder]
    $where: BlogCategoryFilter
    $preview: Boolean
  ) {
    blogCategoryCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseBlogCategoryFragment
      }
    }
  }
`;

/**
 * Get all BlogCategory entries with pagination (standard - 1 level deep)
 */
export const getBlogCategorys = gql`
  ${BlogCategoryFragment}

  query GetBlogCategorys(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BlogCategoryOrder]
    $where: BlogCategoryFilter
    $preview: Boolean
  ) {
    blogCategoryCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BlogCategoryFragment
      }
    }
  }
`;

/**
 * Get all BlogCategory entries with pagination (full - 2 levels deep)
 */
export const getFullBlogCategorys = gql`
  ${FullBlogCategoryFragment}

  query GetFullBlogCategorys(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [BlogCategoryOrder]
    $where: BlogCategoryFilter
    $preview: Boolean
  ) {
    blogCategoryCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullBlogCategoryFragment
      }
    }
  }
`;
